import { File } from '@components/fields/file/models/file';
import { IFileButton } from '@components/fields/file/interfaces/file-button';
import { FileComponent } from '@components/fields/file/component/file.component';

export const FileComponent_OnButtonAction = 'FileComponent_OnButtonAction';

export const FileComponent_InitItemButtons = 'FileComponent_InitItemButtons';

/**
 * Компонент FileComponent, хук OpenModule
 * Загрузка модуля по ссылке
 */
export interface IFileComponent_OnButtonAction {
    type: string;
    value: File | null;
    moduleName: string | null;
}

/**
 * Компонент FileComponent, хук LoadIcons
 * Отобразить пиктограммы в File Component
 */
export interface IFileComponent_InitItemButtons {
    itemButtons: IFileButton[];
    translateName: string | null;
    data: FileComponent;
}
